import { render } from "./index_v2.vue?vue&type=template&id=2cdc8446&scoped=true"
import script from "./index_v2.vue?vue&type=script&lang=js"
export * from "./index_v2.vue?vue&type=script&lang=js"

import "./index_v2.vue?vue&type=style&index=0&id=2cdc8446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdc8446"]])

export default __exports__